export const TOGGLE_MENU = "layout.TOGGLE_MENU";
export const TOGGLE_MAIN_PAGE_TAB = "layout.TOGGLE_MAIN_PAGE_TAB";